let CSRF_CACHE: string | null = null;
let fetching = false;
let waiters: Array<(v: string | null) => void> = [];

export function getCachedCsrf() {
  return CSRF_CACHE;
}

export async function ensureCsrf(apiBase: string): Promise<string | null> {
  if (CSRF_CACHE) return CSRF_CACHE;
  if (fetching) {
    return new Promise(resolve => waiters.push(resolve));
  }
  fetching = true;
  try {
    const r = await fetch(`${apiBase}/auth/me`, {
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
    });
    if (!r.ok) return done(null);
    const j = await r.json().catch(() => ({}));
    return done(j?.csrf ?? null);
  } catch {
    return done(null);
  }
}

function done(val: string | null) {
  CSRF_CACHE = val;
  fetching = false;
  waiters.splice(0).forEach(w => w(val));
  return val;
}

export function clearCsrf() {
  CSRF_CACHE = null;
} 